import { useNavigate } from 'react-router-dom';

import { ContentEntityTypeForm } from '../components/ContentEntityTypeForm';

export const EditContentEntityTypePage = () => {
  const navigate = useNavigate();

  return (
    <div className="p-10">
      <div>
        <ContentEntityTypeForm
          type="Edit"
          onSubmit={async (contentEntityTypeId) => {
            navigate(`/content-entity-types`);
          }}
          onCancel={() => {
            navigate(`/content-entity-types`);
          }}
        />
      </div>
    </div>
  );
};
